var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg033Expand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2H21C21.5523 2 22 2.44772 22 3V10C22 10.5523 21.5523 11 21 11C20.4477 11 20 10.5523 20 10V5.41L14.71 10.71C14.5222 10.8993 14.2666 11.0058 14 11.0058C13.7334 11.0058 13.4778 10.8993 13.29 10.71C13.1007 10.5222 12.9942 10.2666 12.9942 10C12.9942 9.73336 13.1007 9.47777 13.29 9.29L18.59 4H14C13.4477 4 13 3.55228 13 3C13 2.44772 13.4477 2 14 2ZM10 12.9942C10.2666 12.9942 10.5222 13.1007 10.71 13.29C10.8993 13.4778 11.0058 13.7334 11.0058 14C11.0058 14.2666 10.8993 14.5222 10.71 14.71L5.41 20H10C10.5523 20 11 20.4477 11 21C11 21.5523 10.5523 22 10 22H3C2.44772 22 2 21.5523 2 21V14C2 13.4477 2.44772 13 3 13C3.55228 13 4 13.4477 4 14V18.59L9.29 13.29C9.47777 13.1007 9.73336 12.9942 10 12.9942Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg033Expand);
export default __webpack_public_path__ + "static/media/033-expand.eba1ba6e1b207a74de947bfc33a78116.svg";
export { ForwardRef as ReactComponent };